import React, { useState, useEffect } from "react";
import {
	Grid,
	Typography,
	Button,
	TextField,
	MenuItem,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow,
	Paper,
	TablePagination,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle
} from "@mui/material";
import { NavLink } from "react-router-dom";
import SaveIcon from "@mui/icons-material/Save";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
import { AiOutlineSearch } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import { getLoadLimitList } from "../../redux/actions/getLoadLimitListAction";
import { addOrUpdateLoadLimit } from "../../redux/actions/addOrUpdateLoadLImitAction";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import EditIcon from "@mui/icons-material/Edit";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";

const useStyles = makeStyles({
	table: {
		minWidth: 650
	}
});

const LoadLimit = () => {
	const [isLoading, setIsLoading] = useState(false);
	const [level, setLevel] = useState("");
	const [page, setPage] = useState(0);
	const [open, setOpen] = React.useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(5);
	const [getLoadLimitStatus, setGetLoadLimitStatus] = useState(false);
	const [getLoadLimitResArray, setgetLoadLimitResArray] = useState([]);
	const [updateLoadLimit, setUpdateLoadLimit] = useState(false);
	const [notificationOpen, setNotificationOpen] = React.useState(false);
	const [limitId, setLimitId] = useState("");
	const [editCurrency, setEditCurrency] = useState("");
	const [editLevel, setEditLevel] = useState("");
	const [editDailyAmountLimit, setEditDailyAmountLimit] = useState("");
	const [editWeeklyAmountLimit, setEditWeeklyAmountLimit] = useState("");
	const [editMonthlyAmountLimit, setEditMonthlyAmountLimit] = useState("");
	const [editYearlyAmountLimit, setEditYearlyAmountLimit] = useState("");
	const [updateLoadLimitResArray, setUpdateLoadLimitResArray] = useState("");

	// const partnerloginUser = useSelector(({ login }) => login);
	// var authToken = partnerloginUser.data.AuthToken;

	const regenerateTokenRes = useSelector(
		({ regenerateToken }) => regenerateToken
	);
	// console.log("regenerateTokenRes", regenerateTokenRes);
	var authToken = regenerateTokenRes.data.AuthToken;

	const classes = useStyles();
	const dispatch = useDispatch();

	const getLoadLimitRes = useSelector(
		({ getLoadLimitList }) => getLoadLimitList
	);

	const updateLoadLimitRes = useSelector(
		({ addOrUpdateLoadLimit }) => addOrUpdateLoadLimit
	);

	// console.log(
	// 	updateLoadLimitRes,
	// 	"////////////////////////////////////////////////////////"
	// );

	const adminCurrencyList = useSelector(
		({ adminCurrencyList }) => adminCurrencyList
	);

	const handleNoticationClose = () => {
		setNotificationOpen(false);
	};

	const handleChange = ({ target: { name, value } }) => {
		if (name === "level") {
			setLevel(value == "Select Level" ? "" : value);
			// setLevel(value);
		}

		if (name === "EditCurrency") {
			setEditCurrency(value);
		}

		if (name === "EditLevel") {
			setEditLevel(value);
		}

		if (name === "EditDailyAmountLimit") {
			//  setEditDailyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditDailyAmountLimit(value)
				: setEditDailyAmountLimit(editDailyAmountLimit);
		}

		if (name === "EditWeeklyAmountLimit") {
			// setEditWeeklyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditWeeklyAmountLimit(value)
				: setEditWeeklyAmountLimit(editWeeklyAmountLimit);
		}

		if (name === "EditMonthlyAmountLimit") {
			//      setEditMonthlyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditMonthlyAmountLimit(value)
				: setEditMonthlyAmountLimit(editMonthlyAmountLimit);
		}

		if (name === "EditYearlyAmountLimit") {
			//  setEditYearlyAmountLimit(value);
			Util.verifyAmount(value)
				? setEditYearlyAmountLimit(value)
				: setEditYearlyAmountLimit(editYearlyAmountLimit);
		}
	};

	const getLoadLimit = () => {
		setGetLoadLimitStatus(true);
		setIsLoading(true);
		const getLoadLimitReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				level: level
			}
		};

		return dispatch(getLoadLimitList(getLoadLimitReq, authToken));
	};

	useEffect(() => {
		if (regenerateTokenRes.data.status == "success") {
			getLoadLimit();
		}
	}, [regenerateTokenRes.data.status]);

	const getLoadLimitStatusFunc = () => {
		if (getLoadLimitStatus) {
			if (getLoadLimitRes.data.status == "success") {
				setIsLoading(false);
				setgetLoadLimitResArray([].concat(getLoadLimitRes.data.loadLimitList));
			}
			if (getLoadLimitRes.data.status == "failed") {
				setIsLoading(false);
				setgetLoadLimitResArray(getLoadLimitRes.data);
				if (
					getLoadLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getLoadLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getLoadLimitRes.data.status == "Failed") {
				setIsLoading(false);
				setgetLoadLimitResArray(getLoadLimitRes.data);
				if (
					getLoadLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					getLoadLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (getLoadLimitRes.data.status == "NOT FOUND") {
				setIsLoading(false);
				setgetLoadLimitResArray(getLoadLimitRes.data);
			}
		}
	};

	useEffect(() => {
		if (getLoadLimitRes.data.status == "success") {
			setPage(0);
		}
	}, [getLoadLimitRes.data.status]);

	const handleChangePage = (event, newPage) => {
		setPage(newPage);
	};

	const handleChangeRowsPerPage = (event) => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const handleClose = () => {
		setOpen(false);
	};

	const updateLoadLimitFunc = () => {
		setOpen(false);
		setUpdateLoadLimit(true);
		const addOrUpdateLoadLimitReq = {
			loginDetails: {
				walletOwnerId: regenerateTokenRes.data.partnerId || ""
			},
			actionCustomerMasterRequestVO: {
				currency: editCurrency,
				level: editLevel,
				dailyLimit: editDailyAmountLimit,
				weeklyLimit: editWeeklyAmountLimit,
				monthlyLimit: editMonthlyAmountLimit,
				yearlyLimit: editYearlyAmountLimit,
				limitId: limitId
			}
		};

		return dispatch(addOrUpdateLoadLimit(addOrUpdateLoadLimitReq, authToken));
	};

	const editLoadLimit = (
		limitId,
		currencyName,
		level,
		daily,
		weekly,
		monthly,
		yearly
	) => {
		setLimitId(limitId);
		setEditCurrency(currencyName);
		setEditLevel(level);
		setEditDailyAmountLimit(daily);
		setEditWeeklyAmountLimit(weekly);
		setEditMonthlyAmountLimit(monthly);
		setEditYearlyAmountLimit(yearly);
		setOpen(true);
	};

	useEffect(() => {
		getLoadLimitStatusFunc();
	}, [getLoadLimitRes.data.status]);

	const updateLoadCount = () => {
		if (updateLoadLimit) {
			if (updateLoadLimitRes.data.status == "success") {
				setOpen(false);
				setUpdateLoadLimitResArray(updateLoadLimitRes.data);
				setNotificationOpen(true);
				getLoadLimit();
			}
			if (updateLoadLimitRes.data.status == "failed") {
				setOpen(false);
				setUpdateLoadLimitResArray(updateLoadLimitRes.data);
				setNotificationOpen(true);
				if (
					updateLoadLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateLoadLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
			if (updateLoadLimitRes.data.status == "Failed") {
				setOpen(false);
				setUpdateLoadLimitResArray(updateLoadLimitRes.data);
				setNotificationOpen(true);
				if (
					updateLoadLimitRes.data.description == "session out"
				) {
					SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
				if (
					updateLoadLimitRes.data.description == "Authorization failed"
				) {
					regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
				}
			}
		}
	};

	useEffect(() => {
		updateLoadCount();
	}, [updateLoadLimitRes.data.status]);

	return (
		<>
			<Layout>
				<Card>
					{/* <BackButton /> */}
					<Grid
						container
						style={{
							padding: "10px",
							marginTop: "1rem",
							marginLeft: "1rem",
							gap: "16px"
						}}
					>
						<Grid item md={4} sm={12} lg={7}></Grid>
						<Grid item md={4} sm={12} lg={2}>
							<NavLink to="/index/add-load-limit">
								{/* <Button
                  variant="contained"
                  style={{ backgroundColor: "#00b9f5", color: "white" }}
                  size="small"
                >
                  Add Load Limit
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									// onClick={handleNoticationClose}
								>
									Add Load Limit
								</CustomButton>
							</NavLink>
						</Grid>
						<Grid item md={4} sm={12} lg={2} style={{ marginLeft: "1rem" }}>
							<NavLink to="/index/add-load-count">
								{/* <Button
                  variant="contained"
                  style={{ backgroundColor: "#00b9f5", color: "white" }}
                  size="small"
                >
                  Add Load Count
                </Button> */}
								<CustomButton
									style={{
										padding: "8px"
									}}
									// onClick={handleNoticationClose}
								>
									Add Load Count
								</CustomButton>
							</NavLink>
						</Grid>
					</Grid>

					<Grid
						container
						spacing={2}
						style={{ padding: "25px", marginTop: "2rem" }}
					>
						<Grid item sm={12} md={4} lg={4}>
							<TextField
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Level"
								fullWidth={true}
								name="level"
								variant="standard"
								// value={level || ""}
								defaultValue={"Select Level" || level}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="Select Level" selected="Select Level">
									Select Level
								</MenuItem>
								<MenuItem value="BASIC">BASIC</MenuItem>
								<MenuItem value="STANDARD">STANDARD</MenuItem>
								<MenuItem value="PREMIUM">PREMIUM</MenuItem>
								<MenuItem value="SUPREME">SUPREME</MenuItem>
							</TextField>
						</Grid>
						<Grid item sm={12} md={4} lg={4}>
							{/* <Button
								style={{
									marginLeft: "0.7rem",
									backgroundColor: "#00b9f5",
									color: "white",
									marginTop: "9px"
								}}
								endIcon={<AiOutlineSearch />}
								variant="contained"
								onClick={getLoadLimit}
							>
								Search
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={getLoadLimit}
							>
								Search <SearchIcon />
							</CustomButton>
						</Grid>
					</Grid>
				</Card>

				{isLoading ? (
					<LoadingSpinner />
				) : getLoadLimitResArray.length == undefined || !getLoadLimitStatus ? (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									className="themeText"
									variant="body1"
									style={{ fontWeight: "700" }}
								>
									Load Limit Details
								</Typography>
							</Grid>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Alert
									className="my-3 tableHeaderColor"
									variant="secondary"
									// style={{ backgroundColor: "#00b9f5", color: "white" }}
								>
									No Records Found!
								</Alert>
							</Grid>
						</Grid>
					</Card>
				) : (
					<Card>
						<Grid
							container
							style={{
								padding: "10px"
							}}
						>
							<Grid xs={12} sm={12} md={12} lg={12}>
								<Typography
									className="themeText"
									variant="body1"
									style={{ fontWeight: "700" }}
								>
									Load Limit Details
								</Typography>
							</Grid>
							<TableContainer component={Paper} className="my-3">
								<Table
									className={classes.table}
									size="small"
									aria-label="a dense table"
								>
									<TableHead>
										<TableRow className="tableHeaderColor">
											{/* <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>Sr.No</TableCell> */}
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Level
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Currency
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Daily Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Weekly Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Monthly Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Yearly Amount Limit
											</TableCell>
											<TableCell
												align="center"
												style={{ fontWeight: "bold", color: "white" }}
											>
												Action
											</TableCell>
										</TableRow>
									</TableHead>

									<TableBody>
										{getLoadLimitResArray &&
											[]
												.concat(getLoadLimitResArray)
												.slice(
													page * rowsPerPage,
													page * rowsPerPage + rowsPerPage
												)
												.map((row, index) => (
													<TableRow key={row.limitId}>
														{/* <TableCell align="center">{index + 1}</TableCell> */}
														<TableCell align="center">{row.level}</TableCell>
														<TableCell align="center">
															{row.currencyName}
														</TableCell>
														<TableCell align="center">{row.daily}</TableCell>
														<TableCell align="center">{row.weekly}</TableCell>
														<TableCell align="center">{row.monthly}</TableCell>
														<TableCell align="center">{row.yearly}</TableCell>
														<TableCell align="center">
															<Tooltip title="Edit">
																<CustomButton
																	style={{
																		padding: "8px"
																	}}
																	onClick={() =>
																		editLoadLimit(
																			row.limitId,
																			row.currencyName,
																			row.level,
																			row.daily,
																			row.weekly,
																			row.monthly,
																			row.yearly
																		)
																	}
																>
																	{/* Update */}
																	{
																		<EditIcon
																			style={{
																				color: "#fff",
																				fontSize: "20px"
																			}}
																		/>
																	}
																</CustomButton>
															</Tooltip>
														</TableCell>
													</TableRow>
												))}
									</TableBody>
								</Table>
								<TablePagination
									rowsPerPageOptions={[5, 10, 25]}
									component="div"
									count={getLoadLimitResArray.length}
									rowsPerPage={rowsPerPage}
									page={page}
									onPageChange={handleChangePage}
									onRowsPerPageChange={handleChangeRowsPerPage}
								/>
							</TableContainer>
						</Grid>
					</Card>
				)}
				<div>
					<Dialog open={open} onClose={handleClose}>
						<DialogTitle>Update Load Limit</DialogTitle>
						<DialogContent>
							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Currency"
								fullWidth={true}
								name="EditCurrency"
								value={editCurrency || ""}
								onChange={handleChange}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								{adminCurrencyList.success &&
									[]
										.concat(adminCurrencyList.data.currencyList)
										.map((x) => <MenuItem value={x}>{x}</MenuItem>)}
							</TextField>

							<TextField
								style={{ marginTop: "10px" }}
								select
								size="small"
								color="primary"
								autoFocus={true}
								type="text"
								label="Level"
								fullWidth={true}
								name="EditLevel"
								value={editLevel || ""}
								onChange={handleChange}
								disabled
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							>
								<MenuItem value="">Select Level</MenuItem>
								<MenuItem value="BASIC">BASIC</MenuItem>
								<MenuItem value="STANDARD">STANDARD</MenuItem>
								<MenuItem value="PREMIUM">PREMIUM</MenuItem>
								<MenuItem value="SUPREME">SUPREME</MenuItem>
							</TextField>

							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								variant="standard"

								autoFocus={true}
								type="text"
								label="Daily Amount Limit"
								value={editDailyAmountLimit || ""}
								name="EditDailyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								variant="standard"

								type="text"
								label="Weekly Amount Limit"
								value={editWeeklyAmountLimit || ""}
								name="EditWeeklyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								variant="standard"

								type="text"
								label="Monthly Amount Limit"
								value={editMonthlyAmountLimit || ""}
								name="EditMonthlyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
							<TextField
								required
								style={{ marginTop: "10px" }}
								size="small"
								color="primary"
								autoFocus={true}
								variant="standard"

								type="text"
								label="Yearly Amount Limit"
								value={editYearlyAmountLimit || ""}
								name="EditYearlyAmountLimit"
								fullWidth={true}
								onChange={handleChange}
								InputProps={{
									sx: {
									  "&:before": { borderBottomColor: "gray" }, // before focus
									  "&:after": { borderBottomColor: "gray" },  // after focus
									},
								  }}
								  InputLabelProps={{
									sx: { color: 'gray' }, // Optional: if you want the label to be white
								  }}
							></TextField>
						</DialogContent>
						<DialogActions>
							<Button
								style={{
									backgroundColor: "#fff",
									color: "#000"
								}}
								variant="contained"
								onClick={handleClose}
							>
								Cancel
							</Button>
							{/* <Button
								style={{
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={updateLoadLimitFunc}
							>
								Save
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={updateLoadLimitFunc}
								endIcon={<SaveIcon />}
							>
								Save <SaveIcon />
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			</Layout>

			{updateLoadLimitResArray.status == "success" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={success} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateLoadLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateLoadLimitResArray.status == "failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateLoadLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}

			{updateLoadLimitResArray.status == "Failed" && (
				<div>
					<Dialog open={notificationOpen} onClose={handleNoticationClose}>
						<DialogContent
							className="text-center"
							style={{ backgroundColor: "#00b9f51c" }}
						>
							<img src={failed} alt="" width="100px" className="my-2" />
						</DialogContent>
						<DialogContent>
							<h4
								style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
							>
								{updateLoadLimitResArray.description}
							</h4>
						</DialogContent>
						<DialogActions style={{ justifyContent: "center" }}>
							{/* <Button
								style={{
									margin: "10px 0",
									backgroundColor: "#00b9f5",
									color: "white"
								}}
								variant="contained"
								onClick={handleNoticationClose}
							>
								Ok
							</Button> */}
							<CustomButton
								style={{
									padding: "8px"
								}}
								onClick={handleNoticationClose}
								// endIcon={<SaveIcon />}
							>
								Ok
							</CustomButton>
						</DialogActions>
					</Dialog>
				</div>
			)}
		</>
	);
};

export default LoadLimit;
